import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { QuestionSetAction, QuestionSetConfig } from '@/shared/types/action';
import { QUESTION_TYPE_LABEL_KEYS } from '@/util/validation/schemas/question-set-schemas';

type QuestionSetContentProps = { questionSet?: QuestionSetConfig };

/**
 * Read-only view of a question set: the title and one row per question.
 * Shared by the dialog canvas card and the Try It and human chat transcripts.
 */
export const QuestionSetContent = ({ questionSet }: QuestionSetContentProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      {questionSet?.title && <strong className="text-sm">{questionSet.title}</strong>}
      <ol className="flex flex-col gap-1">
        {(questionSet?.questions ?? []).map((question) => (
          <li key={question.key} className="flex items-center gap-2 text-sm">
            <span className="min-w-0 flex-1 truncate">
              <span className="font-medium">{question.header}</span>
              <span className="text-foreground-muted"> · {question.question}</span>
            </span>
            <Badge type="outline" size="xs" className="shrink-0">
              {t(QUESTION_TYPE_LABEL_KEYS[question.type])}
            </Badge>
          </li>
        ))}
      </ol>
    </div>
  );
};

type QuestionSetProps = { action: QuestionSetAction };

const QuestionSet = ({ action }: QuestionSetProps) => (
  <QuestionSetContent questionSet={action.question_set} />
);

export default QuestionSet;
